import React, { useEffect } from 'react';
import { api, clearToken } from '@/lib/api';
import Generic404 from './Generic404';

// Honeypot trap for guessable default routes (/admin, /login, /dashboard, ...).
// Logs a "Security Scan / Invalid Navigation Event", invalidates the session
// server-side, clears the local token, then dead-ends in a generic 404.
export default function Honeypot() {
  useEffect(() => {
    (async () => {
      try {
        await api.post('/security/event', { path: window.location.pathname, invalidate: true });
      } catch { /* stay silent — reveal nothing */ }
      clearToken();
    })();
  }, []);
  return <Generic404 />;
}
